<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 300px;" class="mr-1">
								<v-select :items="selectGoodsList" v-model="query.goodsId"
								item-text="goodsName" item-value="id" label="商品" dense outlined clearable></v-select>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-text-field outlined placeholder="匹配交接人或备注信息" label="交接人/备注" v-model="query.userName" clearable dense></v-text-field>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								    transition="scale-transition" offset-y
									min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="创建开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start"  @input="menu1=false" no-title scrollable>
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									 transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="创建结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable>
									</v-date-picker>
								</v-menu>
							</div>
							<v-btn @click="getTableDataList" color="primary">查询</v-btn>
						</v-col>
						
					</v-row>
					<v-divider></v-divider>
				</template>
			
				<template v-slot:item.inOut="{item}">
					<v-chip small :color="inOutColor(item.inOut)">{{ inOutName(item.inOut) }}
					</v-chip>
				</template>
				

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="1" >
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="10"   v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

	</v-card>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "cash-journal-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: 'ERP管理中心',
						disabled: true
					},
					{
						text: '出入库记录',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						
						{
							text: '商品',
							value: 'goodsName',
							sortable: false
						},
						{
							text: '出库/入库',
							value: 'inOut',
							sortable: false
						},
						{
							text: '业务类型',
							value: 'bizType',
							sortable: false
						},
						{
							text: '数量',
							value: 'quantity',
							sortable: false
						},
						{
							text: '交接人',
							value: 'bizUserName',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '制单人',
							value: 'creatorName',
							sortable: false
						},
						{
							text: '备注',
							value: 'memo',
							sortable: false
						},
						
					],
					list: [],
				},
				selectGoodsList:[],
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					goodsId:"",
					userName:""
				},
			}
		},
		created() {
			// 获取门店列表
			this.shopId = utils.getCurrentShopId();
			this.getGoodsListForSelect();
			this.getTableDataList();
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/erp/stock/journal/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				
				if (this.query.goodsId) {
					url += "&goodsId=" + this.query.goodsId;
				}
				if (this.query.userName && this.query.userName.trim()) {
					url += "&userName=" + encodeURIComponent(this.query.userName.trim());
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			inOutName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "入库";
				} else if (state === "2") {
					stName = "出库";
				}
				return stName;
			},
			inOutColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "error";
				}
				return color;
			},
			getGoodsListForSelect(){
				const that = this;
				let url = `/erp/merchant/goods/list`;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectGoodsList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
</script>

<style>
</style>
